import * as React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import Button from '../../Components/Button';
import Row from '../../Components/Row';
import TextArea from '../../Components/TextArea';
import TextInput from '../../Components/TextInput';
import TitleSelect from '../../Components/TitleSelect';
import StringFormatter from '../../Helpers/StringFormatter';
import Validator from '../../Helpers/validator';
import Product from '../../Models/Product';
import * as Modules from '../../Modules';
import DonationTypeDetail from '../Types/DonationTypeDetail';
import Member from '../Types/Member';
import MemberAddress from '../Types/MemberAddress';
import MemberPersonalInfo from '../Types/MemberPersonalInfo';
import Project from '../Types/Project';
import { LookupAddress, RetrieveAddress, RetrieveItem } from '../../Helpers/Loqate';
import Country from '../Types/Country';
import Checkbox from '../../Components/Checkbox';
import { DonationTypeOption } from '../../Modules/DonationTypeModule';

export interface Props {
  setDonationTypeOption: (selectedOptionId: string) => void;
  setCustomEntry: (customValue: string) => void;

  loqateApiKey: string;

  product?: Product;
  member: Member;
  project: Project;
  isAddressFinderEnabled: boolean;
  isPhoneRegexValidation: boolean;
  reCaptchaKey?: string;

  buttonClass?: string;
  postalAdddressBackgroundClass?: string;
  commentEnabled?: boolean;
  countryList?: Country[];
  paymentSelection?: string;
  showPreferNotToSay: boolean;
  titlesList: string[];

  showOrganisationField?: boolean;

  donationTypeOptions?: DonationTypeOption[];
  donationTypeOtherId?: string;
  donationTypeDefaultId?: string;

  updateMember(mutate: (member: Member) => void): void;
  submit(): void;
  
}

interface State {
  highlightErrors: boolean;
  reCaptchaValid: boolean;

  locatedAddresses: { Id: string; Text: string }[];
  didAddressSearch: boolean;

  donationTypeSelectedId: string;
  donationTypeCustomValue: string;
}

export default class MembershipSignupMemberDetails extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      highlightErrors: false,

      reCaptchaValid: props.reCaptchaKey ? false : true,

      locatedAddresses: [],
      didAddressSearch: false,

      donationTypeSelectedId: '',
      donationTypeCustomValue: '',
    };
  }

  handlePostcodeLookup = async (postcode: string, countryCode?: string) => {
    // const postcode = this.props.member.address.postcode;

    this.setState({ locatedAddresses: [], didAddressSearch: false });

    try {
      const addresses = await LookupAddress(postcode, this.props.loqateApiKey, countryCode);

      this.setState({ locatedAddresses: addresses.map(a => { return { Id: a.Id, Text: a.Text }; }), didAddressSearch: true });

    } catch (error) {
      this.setState({ locatedAddresses: [], didAddressSearch: true });
    }
  };

  handleAddressSelect = async (postcodeId: string) => {
    const address = await RetrieveAddress(postcodeId, this.props.loqateApiKey);

    this.props.updateMember(member => this.formatAddressFields(address));
  };

  formatAddressFields = (address: RetrieveItem) => {
    let member = this.props.member;
    if (address.Company !== '') {
      member.address.line1 = address.Company;
      member.address.line2 = address.Line1 + ', ' + address.Line2;
      member.address.county = address.ProvinceName;
      member.address.town = address.City;
      member.address.country = address.CountryName;
      member.address.countryIso = address.CountryIso2;
    } else {
      member.address.line1 = address.Line1;
      member.address.line2 = address.Line2;
      member.address.county = address.ProvinceName;
      member.address.town = address.City;
      member.address.country = address.CountryName;
      member.address.countryIso = address.CountryIso2;
    }

    return member;
  }

  donationTypeOptionSelected = (selectedOptionId: string): void => {
    this.setState({ donationTypeSelectedId: selectedOptionId });
    this.props.setDonationTypeOption(selectedOptionId);
  }

  donationTypeCustomValueChanged = (customValue: string): void => {
    this.setState({ donationTypeCustomValue: customValue });
    this.props.setCustomEntry(customValue);
  }

  handleSubmit = () => {
    this.setState({ ...this.state, highlightErrors: true });

    let member = this.props.member;

    if (
      Validator.isEmailAddress(member.personalInfo.email) &&
      member.personalInfo.confirmEmail === member.personalInfo.email &&
      Validator.isNotEmpty(member.personalInfo.firstName) &&
      Validator.isNotEmpty(member.personalInfo.lastName)) {
      if (
        (Validator.isNotEmpty(member.address.line1) &&
          Validator.isNotEmpty(member.address.town) &&
          Validator.isNotEmpty(member.address.country) &&
          Validator.isNotEmpty(member.address.postcode))
      ) {

          this.props.submit();
        
      }
      
    }
    
  };

  updateMemberPersonal = (mutator: (p: MemberPersonalInfo) => void) => {
    let updated = { ...this.props.member.personalInfo };

    mutator(updated);

    this.props.updateMember(m => (m.personalInfo = updated));
  };

  updateMemberDonation = (mutator: (p: DonationTypeDetail) => void) => {
    let updated = { ...this.props.member.donation };

    mutator(updated);

    this.props.updateMember(m => (m.donation = updated));
  };

  public updateMemberAddress = (mutator: (p: MemberAddress) => void) => {
    let updated = { ...this.props.member.address };

    mutator(updated);
    
    this.props.updateMember(m => (m.address = updated));
  };

  handleSubscribe = () => {
    this.setState({
      reCaptchaValid: true
    });
  }

  resetSubscriber = () => {
    this.setState({
      reCaptchaValid: false
    });
  }

  render() {
    const renderThankYouMessage = () => {
      if (this.props.product && this.props.project) {
        const msg = `You have generously agreed to give 
        ${this.props.product.priceSymbol}${StringFormatter.numberAsCurrency(this.props.product.priceInPence)}${this.props.paymentSelection === 'monthly' ? '/month' : ''}
        to support our ${this.props.project.title} appeal. Please complete the form below.`;

        return <div className="col s12"><h4>{msg}</h4></div>;
      }

      return null;
    };

    var titleDivClass = this.props.showPreferNotToSay ? 'col s12 m12' : 'col s12 m12';
    return (
      <Row>

        {renderThankYouMessage()}
        <TextInput
          key={'firstName'}
          id={'firstName'}
          value={this.props.member.personalInfo.firstName}
          label={'First Name *'}

          divClasses={'col s12 m6'}

          onChange={v => this.updateMemberPersonal(o => (o.firstName = v))}
          validator={Validator.isNotEmpty}
          dataInvalidMessage={'First Name is required.'}
          forceHighlightErrors={this.state.highlightErrors}
        />

        <TextInput
          key={'lastName'}
          id={'lastName'}
          value={this.props.member.personalInfo.lastName}
          label={'Last Name *'}

          divClasses={'col s12 m6'}

          onChange={v => this.updateMemberPersonal(o => (o.lastName = v))}
          validator={Validator.isNotEmpty}
          dataInvalidMessage={'Last Name is required.'}
          forceHighlightErrors={this.state.highlightErrors}
        />
        
        {
          this.props.showOrganisationField &&
          
          <TextInput
            key={'organisation'}
            id={'organisation'}
            value={this.props.member.personalInfo.organisation || ''}
            label={'Organisation'}
            divClasses={'col s12'}

            onChange={v => this.updateMemberPersonal(o => (o.organisation = v))}
          />
        }

        <TextInput
          key={'phone'}
          id={'phone'}
          value={this.props.member.personalInfo.phone}
          label={'Phone'}

          divClasses={'col s12'}

          onChange={v => this.updateMemberPersonal(o => (o.phone = v))}
          validator={(p: string) => !Validator.isNotEmpty(p) || Validator.isPhoneNumber(p, this.props.isPhoneRegexValidation)}
          dataInvalidMessage={'Phone Number is not valid.'}
          forceHighlightErrors={this.state.highlightErrors}
        />

        <TextInput
          key={'email'}
          id={'email'}
          value={this.props.member.personalInfo.email}
          label={'Email *'}

          divClasses={'col s12'}

          onChange={v => this.updateMemberPersonal(o => (o.email = v))}
          validator={Validator.isEmailAddress}
          dataInvalidMessage={'A valid email address is required.'}
          forceHighlightErrors={this.state.highlightErrors}
        />

        <TextInput
          key={'confirmEmail'}
          id={'confirmEmail'}
          value={this.props.member.personalInfo.confirmEmail}
          label={'Confirm Email *'}
          divClasses={'col s12'}
          onChange={v => this.updateMemberPersonal(o => (o.confirmEmail = v))}
          validator={(s: string) => s === this.props.member.personalInfo.email}
          dataInvalidMessage={'Confirm email should be same as email.'}
          forceHighlightErrors={this.state.highlightErrors}
        />

        <hr />

        <Modules.AddressModule
          member={this.props.member}
          locatedAddresses={this.state.locatedAddresses}
          didAddressSearch={this.state.didAddressSearch}
          postalAdddressBackgroundClass={this.props.postalAdddressBackgroundClass}
          handleAddressSelect={this.handleAddressSelect}
          handlePostcodeLookup={this.handlePostcodeLookup}
          updateMemberAddress={this.updateMemberAddress}
          isAddressFinderEnabled={this.props.isAddressFinderEnabled}
          countryList={this.props.countryList}
        />

        {
          this.props.donationTypeOptions
          && this.props.donationTypeDefaultId
          && this.props.donationTypeOptions.length > 0 ? 
          <Modules.DonationType
            options={this.props.donationTypeOptions}
            otherId={this.props.donationTypeOtherId || ''}
            defaultId={this.props.donationTypeDefaultId}
            selectedOption={this.state.donationTypeSelectedId}
            customValue={this.state.donationTypeCustomValue}

            setDonationTypeOption={this.donationTypeOptionSelected}
            setCustomEntry={this.donationTypeCustomValueChanged}
          /> : <></>
        }

        {this.props.commentEnabled &&
        <TextArea
          key={'comment'}
          id={'comment'}
          value={this.props.member.donation.comment}
          label={'Comment'}
          divClasses={'col s12'}

          onChange={v => this.updateMemberDonation(o => (o.comment = v))}
        />
        }
        <Row>
          <div className="col s12 m12 l12 xl12">&nbsp;</div>
        </Row>
        <hr />

        {this.props.children}

        {
          this.props.reCaptchaKey
            ? (
              <Row>
                <br />
                <ReCAPTCHA
                  sitekey={this.props.reCaptchaKey}
                  onChange={this.handleSubscribe}
                  onExpired={this.resetSubscriber}
                  onErrored={this.resetSubscriber}
                />
              </Row>
            )
            : <Row>&nbsp;</Row>
        }

        <Row>
          <div className="col s12 submission-block offset-m6 m6">
            <Button
              disabled={!this.state.reCaptchaValid}
              className={`btn ${this.props.buttonClass}`}
              onClick={this.handleSubmit}
            >
              Go To Payment
            </Button>
          </div>
        </Row>

      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/MakeDonation/SignupJourney/PersonalDetails.tsx